var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready && this.$route.meta.public)?_c('LayoutPublic',[_c('router-view')],1):(_vm.ready && this.$route.meta.requiresAuth)?_c('LayoutApp',[_c('router-view')],1):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }